module.exports = __webpack_public_path__ + "static/media/splitGreen.423533f5.svg";